import { types } from 'mobx-state-tree';
import moment, { Moment } from 'moment';

export const NullableMomentDate = types.custom<string, Moment | null>({
  name: 'MomentDate',

  fromSnapshot(value: string): Moment | null {
    if (value && value !== '') {
      return moment(value);
    }

    return null;
  },
  toSnapshot(value: Moment): string {
    if (value) {
      return value.toISOString();
    }

    return '';
  },
  isTargetType(value: never) {
    return moment.isMoment(value);
  },
  getValidationMessage(value: never) {
    if (moment.isMoment(value)) {
      return 'Invalid moment object';
    }
    return '';
  },
});
